export default "__VITE_ASSET__BGRiojHS__"